function Activities() {
  return (
    <div className="activities">
      <h2>Our Activities 🎈</h2>

      <div className="activity-box">
        <div>🧘 Yoga</div>
        <div>🎵 Music</div>
        <div>🎨 Craft</div>
        <div>🧠 Brain Games</div>
        <div>📖 Storytelling</div>
        <div>🎈 Play Time</div>
      </div>
    </div>
  );
}

export default Activities;